export default __webpack_public_path__ + "static/media/forest.20e60ab0.png";